import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ModelsService } from './modelsApi';
import { AxiosError } from 'axios';

const initialState: any = {
    modelsAreLoading: false,
    modelsIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToEditModel = createAsyncThunk<any, any>(
    'models/tryToEditModel',
    async (data, { rejectWithValue }) => {
        try {
            const result = await ModelsService.tryToEditModel(data);
            return result?.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    }
);

export const tryToFetchModels = createAsyncThunk<any, void>(
    'models/tryToFetchModels',
    async () => {
        const result = await ModelsService.tryToFetchModels();
        return result?.data?.data;
    }
);

export const tryToTriggerRunLeo = createAsyncThunk<any, void>(
    'models/tryToTriggerRunLeo',
    async () => {
        const result = await ModelsService.tryToTriggerRunLeo();
        return result?.data;
    }
);

export const tryToDeleteUserModels = createAsyncThunk<any, any>(
    'models/tryToDeleteUserModels',
    async (data, { rejectWithValue }) => {
        try {
            const result = await ModelsService.tryToDeleteUserModels(data);
            return result?.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    }
);

export const tryToGetUserModels = createAsyncThunk<any, any>(
    'models/tryToGetUserModels',
    async (data) => {
        const result = await ModelsService.tryToGetUserModels(data);
        return result?.data?.data;
    }
);

export const tryToInviteNewMember = createAsyncThunk<any, any>(
    'demoRequests/tryToInviteNewMember',
    async (data, { rejectWithValue }) => {
        try {
            const result = await ModelsService.tryToInviteNewMember(data);
            return result?.data?.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);


export const modelsSlice = createSlice({
    name: 'models',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchModels
            .addCase(tryToFetchModels.pending, (state) => {
                state.modelsAreLoading = true;
            })
            .addCase(tryToFetchModels.rejected, (state) => {
                state.modelsAreLoading = false;
            })
            .addCase(tryToFetchModels.fulfilled, (state, action) => {
                state.modelsAreLoading = false;
                state.models = action.payload;
            })

            // tryToGetUserModels
            .addCase(tryToGetUserModels.pending, (state) => {
                state.modelsAreLoading = true;
            })
            .addCase(tryToGetUserModels.rejected, (state) => {
                state.modelsAreLoading = false;
            })
            .addCase(tryToGetUserModels.fulfilled, (state, action) => {
                state.modelsAreLoading = false;
                state.enabledModels = action.payload;
            })

            // tryToEditModel
            .addCase(tryToEditModel.pending, (state) => {
                state.modelsIsLoading = true;
            })
            .addCase(tryToEditModel.rejected, (state) => {
                state.modelsIsLoading = false;
            })
            .addCase(tryToEditModel.fulfilled, (state, action) => {
                state.modelsIsLoading = false;
                if (state.enabledModels) {
                    const findModel = state?.models?.find((item: any) => item?._id === action?.meta?.arg?.engineIds?.[0])
                    state.enabledModels = [...state.enabledModels || [], findModel || {}]
                }
            })

            // tryToDeleteUserModels
            .addCase(tryToDeleteUserModels.pending, (state) => {
                state.modelsIsLoading = true;
            })
            .addCase(tryToDeleteUserModels.rejected, (state) => {
                state.modelsIsLoading = false;
            })
            .addCase(tryToDeleteUserModels.fulfilled, (state, action) => {
                state.modelsIsLoading = false;
                if (state.enabledModels) {
                    state.enabledModels = { ...state }.enabledModels?.filter((model: any) => model?._id !== action?.meta?.arg?.engineIds?.[0]) || [];
                }
            })

    },
});

export default modelsSlice.reducer;